export default class BreadcrumbService {
  /* @ngInject */
  constructor(RouterService) {
    this.routerService = RouterService;
  }

  createFilterParams(breadcrumbs, breadcrumb) {
    const index = breadcrumbs.findIndex(i => i.id === breadcrumb.id);
    const values = breadcrumbs.slice(0, index + 1);
    const params = values.reduce((obj, value) => {
      obj[`${value.filter}Id`] = value.id;
      return obj;
    }, {});

    const queryString = this.routerService.location.search();
    return {
      ...queryString,
      ...params,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb/breadcrumb.service.js